import React from 'react';
import { ChangePassword, SatCoreRegister } from 'sat-core';

const ChangePasswordOverride = (props) => <ChangePassword {...props} modal={false} />;

SatCoreRegister('ChangePassword', ChangePasswordOverride);
